import { all } from 'redux-saga/effects';
import { salesOrganizationSaga } from './salesOrganisation/slice/saga';
import { configuratorDataSaga } from './configuratorData/slice/saga';
import { changeLanguageSaga } from './erpSystem/slice/saga';
import { priceSaga } from './price/slice/saga';
import { stockSaga } from './stock/slice/saga';
import { metadataSaga } from './metadata/slice/saga';
import { selectServiceSaga } from './selectService/slice/saga';
import { insertsSaga } from './inserts/slice/saga';
import { quoteInformationSaga } from './quote/slice/saga';
import { sapConfigurationSaga } from './sapConfiguration/slice/saga';
import { stemExtensionsDataSaga } from './stemExtensions/slice/saga';
import { mountingPartSaga } from './mountingPart/slice/saga';
import { pucksSaga } from './pucks/slice/saga';
import { speedControlBlockDataSaga } from './speedControlBlock/slice/saga';
import { mountingPlateSaga } from './mountingPlate/slice/saga';
import { couplingsSaga } from './couplings/slice/saga';
// [IMPORT NEW Sagas ABOVE] < Needed for generating containers seamlessly

export default function* rootSaga() {
  yield all([
    salesOrganizationSaga(),
    configuratorDataSaga(),
    changeLanguageSaga(),
    priceSaga(),
    stockSaga(),
    metadataSaga(),
    selectServiceSaga(),
    insertsSaga(),
    quoteInformationSaga(),
    sapConfigurationSaga(),
    stemExtensionsDataSaga(),
    mountingPartSaga(),
    pucksSaga(),
    speedControlBlockDataSaga(),
    mountingPlateSaga(),
    couplingsSaga(),
    // [INVOKE NEW Saga Above] < Needed for generating containers seamlessly
  ]);
}
